import PageWrapper from "../../components/common/layout/PageWrapper";
import { useTranslation } from "react-i18next";
import useAppSelector from "../../../hooks/redux/base/useAppSelector";
import SeAdditionalDocNew from "../../components/services/additionalDoc/SeAdditionalDocNew";

const SeAdditionalDocNewPage = () => {
  const { t } = useTranslation();

  const selectedService = useAppSelector((state) => {
    return state.SelectedService;
  });

  return (
    <PageWrapper title={t(`${selectedService.titleCode}.new`)}>
      <SeAdditionalDocNew />
    </PageWrapper>
  );
};

export default SeAdditionalDocNewPage;
